export default {
  noActiveRecipe: 'Na tejto peci nie je aktívny žiaden recept.',
};
